import Axios from 'axios'

export default function Request(store, router) {
  const setError = message => {
    store.dispatch('addNotification', {
      type: 'danger',
      message,
    })
  }
  const api = Axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}`,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  api.interceptors.request.use(config => {
    if (store.getters.token) {
      config.headers.Authorization = `Bearer ${store.getters.token}`
    }
    return config
  })

  api.interceptors.response.use(
    res => res,
    ({ response }) => {
      if (response.status === 401) {
        router.push('/logout')
        setError('Błędny login lub hasło')
        return Promise.reject()
      }

      setError(response.data.title || response.data)
      return Promise.reject()
    }
  )
  return api
}
